<script setup lang="ts">
import { ref } from "vue";

const TAG_AND_TAG_SPACING = 4;

const scrollWrapper = ref<HTMLElement>();

defineExpose({
    /** 把指定 tag 元素滚动到可视区 */
    moveToTarget(target: HTMLElement) {
        if (!scrollWrapper.value) return;
        const wrap = scrollWrapper.value;
        const wrapRect = wrap.getBoundingClientRect();
        const tagRect = target.getBoundingClientRect();

        const outLeft = tagRect.left < wrapRect.left;
        const outRight = tagRect.right > wrapRect.right - TAG_AND_TAG_SPACING;

        if (outLeft) {
            wrap.scrollLeft += tagRect.left - wrapRect.left - TAG_AND_TAG_SPACING;
        } else if (outRight) {
            wrap.scrollLeft += tagRect.right - wrapRect.right + TAG_AND_TAG_SPACING;
        }
    },
    /** 鼠标滚轮横向滚动 */
    handleWheel(e: WheelEvent) {
        if (!scrollWrapper.value) return;
        const delta = e.deltaY || e.deltaX;
        scrollWrapper.value.scrollLeft += delta;
    },
});

function onWheel(e: WheelEvent) {
    e.preventDefault();
    if (!scrollWrapper.value) return;
    scrollWrapper.value.scrollLeft += e.deltaY || e.deltaX;
}
</script>

<template>
    <div ref="scrollWrapper" class="scroll-wrapper" @wheel="onWheel">
        <slot />
    </div>
</template>

<style lang="scss" scoped>
.scroll-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
        display: none;
    }
}
</style>
